import React from "react"

import CloseRoundedIcon from "@mui/icons-material/CloseRounded"

import { DetectiveCluxItem } from "../../config/interfaces"

import "./style.scss"

interface TileProps {
  item: DetectiveCluxItem
  /** Tuile éteinte (élément écarté par le joueur) */
  isOff?: boolean
  /** Joue l'effet de tremblement : la sélection de cette tuile vient d'être refusée */
  isShaking?: boolean
  /** Si absent, la tuile est affichée en lecture seule avec son nom */
  onToggle?: (id: string) => void
  /** Appelé à la fin de l'effet de tremblement */
  onShakeEnd?: () => void
}

/**
 * Tuile d'un personnage, d'un objet ou d'un lieu.
 * Interactive sur le plateau (bouton bascule), en lecture seule dans la modale et les résultats.
 */
const Tile = ({
  item,
  isOff = false,
  isShaking = false,
  onToggle,
  onShakeEnd,
}: TileProps) => {
  const className = `dc-tile dc-tile--${item.type}${isOff ? " is-off" : ""}${
    isShaking ? " is-shaking" : ""
  }`

  if (!onToggle) {
    return (
      <figure className={`${className} is-readonly`}>
        <img className="dc-tile__image" src={item.image} alt="" />
        <figcaption className="dc-tile__caption">{item.label}</figcaption>
      </figure>
    )
  }

  return (
    <button
      type="button"
      className={className}
      aria-pressed={isOff}
      aria-label={`Écarter ${item.label}`}
      title={item.label}
      onClick={() => onToggle(item.id)}
      onAnimationEnd={onShakeEnd}
    >
      <img className="dc-tile__image" src={item.image} alt="" />
      {/* Pictogramme : l'état éteint n'est pas signalé uniquement par la couleur */}
      <span className="dc-tile__off-mark" aria-hidden>
        <CloseRoundedIcon fontSize="inherit" />
      </span>
    </button>
  )
}

export default Tile
